import { TYPES } from '../actions/types';

const initialState = {
  companies: [],
  totalCount: 0,
  currentCompany: null,
  loading: false,
  error: null
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get companies
    case TYPES.ACTION_GET_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: action.payload.data.result || [],
        totalCount: action.payload.data.totalCount || 0,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_GET_COMPANIES_FAIL:
      return {
        ...state,
        companies: [],
        totalCount: 0,
        loading: false,
        error: action.payload
      };

    // Get company by ID
    case TYPES.ACTION_GET_COMPANY_BY_ID_SUCCESS:
      return {
        ...state,
        currentCompany: action.payload.data || action.payload,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_GET_COMPANY_BY_ID_FAIL:
      return {
        ...state,
        currentCompany: null,
        loading: false,
        error: action.payload
      };

    // Get company by company_id
    case TYPES.ACTION_GET_COMPANY_BY_COMPANY_ID_SUCCESS:
      return {
        ...state,
        currentCompany: action.payload.data || action.payload,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_GET_COMPANY_BY_COMPANY_ID_FAIL:
      return {
        ...state,
        currentCompany: null,
        loading: false,
        error: action.payload
      };

    // Create company
    case TYPES.ACTION_CREATE_COMPANY_SUCCESS:
      return {
        ...state,
        companies: [action.payload.data || action.payload, ...state.companies],
        totalCount: state.totalCount + 1,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_CREATE_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Update company
    case TYPES.ACTION_UPDATE_COMPANY_SUCCESS:
      const updatedData = action.payload.data.data || action.payload.data;
      const updatedCompanies = state.companies.map(company =>
        company._id === action.payload.id ? updatedData : company
      );
      
      return {
        ...state,
        companies: updatedCompanies,
        currentCompany: state.currentCompany?._id === action.payload.id 
          ? updatedData 
          : state.currentCompany,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_UPDATE_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Delete company
    case TYPES.ACTION_DELETE_COMPANY_SUCCESS:
      const filteredCompanies = state.companies.filter(company => company._id !== action.payload.id);
      
      return {
        ...state,
        companies: filteredCompanies,
        totalCount: Math.max(0, state.totalCount - 1),
        currentCompany: state.currentCompany?._id === action.payload.id 
          ? null 
          : state.currentCompany,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_DELETE_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default companyReducer;
